import { useEffect, useRef, useState } from "react"

const Video = ({ src, autoPlayThrushold = 0.75, poster }) => {
  const videoRef = useRef()
  const [videoSrc, setVideoSrc] = useState(null)
  const [posterSrc, setPosterSrc] = useState(poster)
  const [videoLoaded, setVideoLoaded] = useState(false)

  useEffect(() => {
    const videoEl = videoRef?.current

    if (!videoEl) return

    const observer = new IntersectionObserver(
      ([{ isIntersecting }]) => {
        if (isIntersecting) {
          if (videoSrc === null) {
            setVideoSrc(src)
            setPosterSrc(poster)
          } else if (videoEl.src && videoLoaded) {
            videoEl.muted = true
            videoEl.play()
          }
        } else {
          if (videoEl.src) videoEl.pause()
        }
      },
      { threshold: autoPlayThrushold }
    )

    observer.observe(videoEl)

    // 👇️ remove the event listener when component unmounts
    return () => {
      observer.unobserve(videoEl)
    }
  }, [
    videoRef,
    videoSrc,
    videoLoaded,
    posterSrc,
    src,
    poster,
  ])

  return (
    <video
      ref={videoRef}
      loop
      src={videoSrc}
      poster={posterSrc}
      onLoadedData={() => setVideoLoaded(true)}
      muted
    />
  )
}

export default Video
